module.exports = __webpack_public_path__ + "static/media/three.5321ce0f.png";